import { Permission } from "../../user-right/enums";
import { UserRolePermissionViewModel } from "../../view-models/user-role-permission.view-model";

export const PERMISSION_ADMIN: UserRolePermissionViewModel[] = [
    new UserRolePermissionViewModel(Permission.DASHBOARD, true, true, true, true),
    new UserRolePermissionViewModel(Permission.SUBPROJECT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.MEASURE, true, true, true, true, [
        new UserRolePermissionViewModel(Permission.INFOS, true, true, true, true),
        new UserRolePermissionViewModel(Permission.STATUS_REPORT, true, true, true, true),
        new UserRolePermissionViewModel(Permission.RATING_UPDATE, true, true, true, true),
        new UserRolePermissionViewModel(Permission.DESCRIPTION, true, true, true, true),
        new UserRolePermissionViewModel(Permission.MILESTONES, true, true, true, true),
        new UserRolePermissionViewModel(Permission.TASKS, true, true, true, true),
        new UserRolePermissionViewModel(Permission.CHANGE_HARTEGRAD, true, true, true, true),
        new UserRolePermissionViewModel(Permission.CREATE_APPROVAL_REQUEST, false, false, false, false),
        new UserRolePermissionViewModel(Permission.APPROVAL_REQUEST_STEP1, false, false, false, false),
        new UserRolePermissionViewModel(Permission.APPROVAL_REQUEST_STEP2, false, false, false, false),
    ]),
    new UserRolePermissionViewModel(Permission.REPORT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.MILESTONES, true, true, true, true),
    new UserRolePermissionViewModel(Permission.TRAINING_CENTER, true, true, true, true),
    new UserRolePermissionViewModel(Permission.PROJECT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.ROLES, true, true, true, true),
    new UserRolePermissionViewModel(Permission.DOCUMENTS, true, true, true, true),
    new UserRolePermissionViewModel(Permission.COMPANIES, false, false, false, false),
    new UserRolePermissionViewModel(Permission.STAFF_MEMBERS, true, true, true, true),
    new UserRolePermissionViewModel(Permission.GANTT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.ROLE_RIGHTS, true, true, true, true)

];

export const PERMISSION_MEASURE_RESPONSIBLE: UserRolePermissionViewModel[] = [
    new UserRolePermissionViewModel(Permission.DASHBOARD, true, true, true, true),
    new UserRolePermissionViewModel(Permission.SUBPROJECT, false, false, false, false),
    new UserRolePermissionViewModel(Permission.MEASURE, true, true, true, true, [
        new UserRolePermissionViewModel(Permission.INFOS, true, true, true, true),
        new UserRolePermissionViewModel(Permission.STATUS_REPORT, true, true, true, true),
        new UserRolePermissionViewModel(Permission.RATING_UPDATE, true, true, true, true),
        new UserRolePermissionViewModel(Permission.DESCRIPTION, true, true, true, true),
        new UserRolePermissionViewModel(Permission.MILESTONES, true, true, true, true),
        new UserRolePermissionViewModel(Permission.TASKS, true, true, true, true),
        new UserRolePermissionViewModel(Permission.CHANGE_HARTEGRAD, false, false, false, false),
        new UserRolePermissionViewModel(Permission.CREATE_APPROVAL_REQUEST, true, true, true, true),
        new UserRolePermissionViewModel(Permission.APPROVAL_REQUEST_STEP1, false, false, false, false),
        new UserRolePermissionViewModel(Permission.APPROVAL_REQUEST_STEP2, false, false, false, false),
    ]),
    new UserRolePermissionViewModel(Permission.REPORT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.MILESTONES, true, true, true, true),
    new UserRolePermissionViewModel(Permission.TRAINING_CENTER, true, true, true, true),
    new UserRolePermissionViewModel(Permission.PROJECT, false, false, false, false),
    new UserRolePermissionViewModel(Permission.ROLES, false, false, false, false),
    new UserRolePermissionViewModel(Permission.COMPANIES, false, false, false, false),
    new UserRolePermissionViewModel(Permission.STAFF_MEMBERS, false, false, false, false),
    new UserRolePermissionViewModel(Permission.GANTT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.DOCUMENTS, false, false, false, false),


];

export const PERMISSION_MEASURE_PARTICIPANT: UserRolePermissionViewModel[] = [
    new UserRolePermissionViewModel(Permission.DASHBOARD, true, true, true, true),
    new UserRolePermissionViewModel(Permission.SUBPROJECT, false, false, false, false),
    new UserRolePermissionViewModel(Permission.MEASURE, true, true, true, true, [
        new UserRolePermissionViewModel(Permission.INFOS, false, false, false, false),
        new UserRolePermissionViewModel(Permission.STATUS_REPORT, true, true, true, true),
        new UserRolePermissionViewModel(Permission.RATING_UPDATE, true, true, true, true),
        new UserRolePermissionViewModel(Permission.DESCRIPTION, false, false, false, false),
        new UserRolePermissionViewModel(Permission.MILESTONES, true, true, true, true),
        new UserRolePermissionViewModel(Permission.TASKS, true, true, true, true),
        new UserRolePermissionViewModel(Permission.CHANGE_HARTEGRAD, false, false, false, false),
        new UserRolePermissionViewModel(Permission.CREATE_APPROVAL_REQUEST, false, false, false, false),
        new UserRolePermissionViewModel(Permission.APPROVAL_REQUEST_STEP1, false, false, false, false),
        new UserRolePermissionViewModel(Permission.APPROVAL_REQUEST_STEP2, false, false, false, false),
    ]),
    new UserRolePermissionViewModel(Permission.REPORT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.MILESTONES, true, true, true, true),
    new UserRolePermissionViewModel(Permission.TRAINING_CENTER, true, true, true, true),
    new UserRolePermissionViewModel(Permission.PROJECT, false, false, false, false),
    new UserRolePermissionViewModel(Permission.ROLES, false, false, false, false),
    new UserRolePermissionViewModel(Permission.COMPANIES, false, false, false, false),
    new UserRolePermissionViewModel(Permission.STAFF_MEMBERS, false, false, false, false),
    new UserRolePermissionViewModel(Permission.GANTT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.DOCUMENTS, false, false, false, false),
];

export const PERMISSION_SUBPROJECT_RESPONSIBLE: UserRolePermissionViewModel[] = [
    new UserRolePermissionViewModel(Permission.DASHBOARD, true, true, true, true),
    new UserRolePermissionViewModel(Permission.SUBPROJECT, true, false, false, true),
    new UserRolePermissionViewModel(Permission.MEASURE, true, true, true, true, [
        new UserRolePermissionViewModel(Permission.INFOS, true, true, true, true),
        new UserRolePermissionViewModel(Permission.DESCRIPTION, true, true, true, true),
        new UserRolePermissionViewModel(Permission.MILESTONES, true, true, true, true),
        new UserRolePermissionViewModel(Permission.TASKS, true, true, true, true),
        new UserRolePermissionViewModel(Permission.STATUS_REPORT, true, true, true, true),
        new UserRolePermissionViewModel(Permission.RATING_UPDATE, true, true, true, true),
        new UserRolePermissionViewModel(Permission.CHANGE_HARTEGRAD, false, false, false, false),
        new UserRolePermissionViewModel(Permission.CREATE_APPROVAL_REQUEST, false, false, false, false),
        new UserRolePermissionViewModel(Permission.APPROVAL_REQUEST_STEP1, false, false, false, false),
        new UserRolePermissionViewModel(Permission.APPROVAL_REQUEST_STEP2, false, false, false, false),
    ]),
    new UserRolePermissionViewModel(Permission.REPORT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.MILESTONES, true, true, true, true),
    new UserRolePermissionViewModel(Permission.TRAINING_CENTER, true, true, true, true),
    new UserRolePermissionViewModel(Permission.PROJECT, false, false, false, false),
    new UserRolePermissionViewModel(Permission.ROLES, false, false, false, false),
    new UserRolePermissionViewModel(Permission.COMPANIES, false, false, false, false),
    new UserRolePermissionViewModel(Permission.STAFF_MEMBERS, false, false, false, false),
    new UserRolePermissionViewModel(Permission.GANTT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.DOCUMENTS, false, false, false, false),
];

export const PERMISSION_SUBPROJECT_DEPUTY: UserRolePermissionViewModel[] = [
    new UserRolePermissionViewModel(Permission.DASHBOARD, true, true, true, true),
    new UserRolePermissionViewModel(Permission.SUBPROJECT, true, false, false, true),
    new UserRolePermissionViewModel(Permission.MEASURE, true, true, true, true, [
        new UserRolePermissionViewModel(Permission.INFOS, true, true, true, true),
        new UserRolePermissionViewModel(Permission.STATUS_REPORT, true, true, true, true),
        new UserRolePermissionViewModel(Permission.RATING_UPDATE, true, true, true, true),
        new UserRolePermissionViewModel(Permission.DESCRIPTION, true, true, true, true),
        new UserRolePermissionViewModel(Permission.MILESTONES, true, true, true, true),
        new UserRolePermissionViewModel(Permission.TASKS, true, true, true, true),
        new UserRolePermissionViewModel(Permission.CHANGE_HARTEGRAD, false, false, false, false),
        new UserRolePermissionViewModel(Permission.CREATE_APPROVAL_REQUEST, false, false, false, false),
        new UserRolePermissionViewModel(Permission.APPROVAL_REQUEST_STEP1, false, false, false, false),
        new UserRolePermissionViewModel(Permission.APPROVAL_REQUEST_STEP2, false, false, false, false),

    ]),
    new UserRolePermissionViewModel(Permission.REPORT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.MILESTONES, true, true, true, true),
    new UserRolePermissionViewModel(Permission.TRAINING_CENTER, true, true, true, true),
    new UserRolePermissionViewModel(Permission.PROJECT, false, false, false, false),
    new UserRolePermissionViewModel(Permission.ROLES, false, false, false, false),
    new UserRolePermissionViewModel(Permission.DOCUMENTS, false, false, false, false),
    new UserRolePermissionViewModel(Permission.STAFF_MEMBERS, false, false, false, false),
    new UserRolePermissionViewModel(Permission.GANTT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.COMPANIES, false, false, false, false),
];


export const PERMISSION_CORE_TEAM: UserRolePermissionViewModel[] = [
    new UserRolePermissionViewModel(Permission.DASHBOARD, true, true, true, true),
    new UserRolePermissionViewModel(Permission.SUBPROJECT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.MEASURE, true, true, true, true, [
        new UserRolePermissionViewModel(Permission.INFOS, true, true, true, true),
        new UserRolePermissionViewModel(Permission.STATUS_REPORT, true, true, true, true),
        new UserRolePermissionViewModel(Permission.RATING_UPDATE, true, true, true, true),
        new UserRolePermissionViewModel(Permission.DESCRIPTION, true, true, true, true),
        new UserRolePermissionViewModel(Permission.MILESTONES, true, true, true, true),
        new UserRolePermissionViewModel(Permission.TASKS, true, true, true, true),
        new UserRolePermissionViewModel(Permission.CHANGE_HARTEGRAD, false, false, false, false),
        new UserRolePermissionViewModel(Permission.CREATE_APPROVAL_REQUEST, false, false, false, false),
        new UserRolePermissionViewModel(Permission.APPROVAL_REQUEST_STEP1, true, true, true, true),
        new UserRolePermissionViewModel(Permission.APPROVAL_REQUEST_STEP2, false, false, false, false),
    ]),
    new UserRolePermissionViewModel(Permission.REPORT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.MILESTONES, true, true, true, true),
    new UserRolePermissionViewModel(Permission.TRAINING_CENTER, true, true, true, true),
    new UserRolePermissionViewModel(Permission.PROJECT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.ROLES, true, true, true, true),
    new UserRolePermissionViewModel(Permission.DOCUMENTS, true, true, true, true),
    new UserRolePermissionViewModel(Permission.STAFF_MEMBERS, true, true, true, true),
    new UserRolePermissionViewModel(Permission.GANTT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.COMPANIES, false, false, false, false),
];

export const PERMISSION_STEERING_COMMITTEE: UserRolePermissionViewModel[] = [
    new UserRolePermissionViewModel(Permission.DASHBOARD, true, true, true, true),
    new UserRolePermissionViewModel(Permission.SUBPROJECT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.MEASURE, true, true, true, true, [
        new UserRolePermissionViewModel(Permission.INFOS, true, true, true, true),
        new UserRolePermissionViewModel(Permission.STATUS_REPORT, true, true, true, true),
        new UserRolePermissionViewModel(Permission.RATING_UPDATE, true, true, true, true),
        new UserRolePermissionViewModel(Permission.DESCRIPTION, true, true, true, true),
        new UserRolePermissionViewModel(Permission.MILESTONES, true, true, true, true),
        new UserRolePermissionViewModel(Permission.TASKS, true, true, true, true),
        new UserRolePermissionViewModel(Permission.CHANGE_HARTEGRAD, false, false, false, false),
        new UserRolePermissionViewModel(Permission.CREATE_APPROVAL_REQUEST, false, false, false, false),
        new UserRolePermissionViewModel(Permission.APPROVAL_REQUEST_STEP1, false, false, false, false),
        new UserRolePermissionViewModel(Permission.APPROVAL_REQUEST_STEP2, true, true, true, true),
    ]),
    new UserRolePermissionViewModel(Permission.REPORT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.MILESTONES, true, true, true, true),
    new UserRolePermissionViewModel(Permission.TRAINING_CENTER, true, true, true, true),
    new UserRolePermissionViewModel(Permission.PROJECT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.ROLES, true, true, true, true),
    new UserRolePermissionViewModel(Permission.DOCUMENTS, true, true, true, true),
    new UserRolePermissionViewModel(Permission.STAFF_MEMBERS, true, true, true, true),
    new UserRolePermissionViewModel(Permission.GANTT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.COMPANIES, false, false, false, false),


];

export const PERMISSION_STRATEGIE_TEAM: UserRolePermissionViewModel[] = [
    new UserRolePermissionViewModel(Permission.DASHBOARD, true, false, false, false),
    new UserRolePermissionViewModel(Permission.SUBPROJECT, true, false, false, false),
    new UserRolePermissionViewModel(Permission.MEASURE, true, false, false, false, [
        new UserRolePermissionViewModel(Permission.INFOS, true, false, false, false),
        new UserRolePermissionViewModel(Permission.STATUS_REPORT, true, true, true, true),
        new UserRolePermissionViewModel(Permission.RATING_UPDATE, true, true, true, true),
        new UserRolePermissionViewModel(Permission.DESCRIPTION, true, false, false, false),
        new UserRolePermissionViewModel(Permission.MILESTONES, true, false, false, false),
        new UserRolePermissionViewModel(Permission.TASKS, true, false, false, false),
        new UserRolePermissionViewModel(Permission.CHANGE_HARTEGRAD, false, false, false, false),
        new UserRolePermissionViewModel(Permission.CREATE_APPROVAL_REQUEST, false, false, false, false),
        new UserRolePermissionViewModel(Permission.APPROVAL_REQUEST_STEP1, false, false, false, false),
        new UserRolePermissionViewModel(Permission.APPROVAL_REQUEST_STEP2, false, false, false, false),
    ]),
    new UserRolePermissionViewModel(Permission.REPORT, true, false, false, false),
    new UserRolePermissionViewModel(Permission.MILESTONES, true, false, false, false),
    new UserRolePermissionViewModel(Permission.TRAINING_CENTER, true, false, false, false),
    new UserRolePermissionViewModel(Permission.PROJECT, true, false, false, false),
    new UserRolePermissionViewModel(Permission.ROLES, true, false, false, false),
    new UserRolePermissionViewModel(Permission.DOCUMENTS, true, false, false, false),
    new UserRolePermissionViewModel(Permission.ROLE_RIGHTS, false, false, false, false),
    new UserRolePermissionViewModel(Permission.STAFF_MEMBERS, true, false, false, false),
    new UserRolePermissionViewModel(Permission.GANTT, true, true, true, true),
    new UserRolePermissionViewModel(Permission.COMPANIES, false, false, false, false),




];